//@ts-check
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography, createStyles } from '@material-ui/core';
export { FORM_ERROR } from 'final-form';

var styles = function styles(theme) {
  return createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      backgroundColor: theme.palette.error.light,
      color: theme.palette.getContrastText(theme.palette.error.light)
    }
  });
};
/**
 * @param {import('./types').FormErrorProps & import('@material-ui/core').WithStyles} props
 */


function FormError(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      sticky = _ref.sticky;
  /** @type {React.CSSProperties} */

  var style = {};

  if (sticky) {
    style.position = 'sticky';
    style.top = 0;
    style.zIndex = 1;
  }

  return React.createElement("div", {
    className: classes.root,
    style: style
  }, React.createElement(Typography, null, children));
}

FormError.defaultProps = {
  sticky: false
};
export default withStyles(styles, {
  name: 'ECFormError'
})(FormError);